import { MerchantInStructure } from '@/types/MerchantInStructure';
import { normalizeText } from '@/utils/normalizeText';
interface UseSearchMerchantChannelProps {
  merchantChannels: MerchantInStructure['channels'];
  setSearchParams: React.Dispatch<
    React.SetStateAction<{
      agent: string;
      channel: string;
    }>
  >;
  channelId?: string;
}

export const useSearchMerchantChannel = ({
  merchantChannels,
  setSearchParams,
  channelId,
}: UseSearchMerchantChannelProps) => {
  const searchChannel = (searchTerm: string) => {
    const searchTermValue = normalizeText(searchTerm).toLowerCase();
    setSearchParams((s) => ({ ...s, channel: searchTermValue }));
    const newMerchantChannels = merchantChannels.filter((channel) => {
      const channelDescriptionIncludesSearchTerm =
        channel.description && normalizeText(channel.description).toLowerCase().includes(searchTermValue);
      const channelUsernameIncludesSearchTerm =
        channel.username && normalizeText(channel.username).toLowerCase().includes(searchTermValue);
      if (channelDescriptionIncludesSearchTerm || channelUsernameIncludesSearchTerm) return channel;
    });
    return newMerchantChannels;
  };

  const searchAgent = (searchTerm: string) => {
    if (searchTerm.length > 0 && searchTerm.length < 2) return [];
    const searchTermValue = normalizeText(searchTerm).toLowerCase();
    setSearchParams((s) => ({ ...s, agent: searchTermValue }));
    const newChannelAgents = merchantChannels.flatMap((channel) =>
      channel.agents.filter((agent) => {
        if (channelId && channel.id !== channelId) return;
        const agentUsernameIncludesSearchTerm =
          agent.username && normalizeText(agent.username).toLowerCase().includes(searchTermValue);
        const agentNameIncludesSearchTerm =
          agent.name && normalizeText(agent.name).toLowerCase().includes(searchTermValue);
        if (agentUsernameIncludesSearchTerm || agentNameIncludesSearchTerm) return channel;
      }),
    );
    return newChannelAgents;
  };
  return { searchAgent, searchChannel };
};
